import { render, staticRenderFns } from "./hafslund.vue?vue&type=template&id=06e92e3a&scoped=true&"
var script = {}
import style0 from "./hafslund.vue?vue&type=style&index=0&id=06e92e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e92e3a",
  null
  
)

export default component.exports